<template>
  <router-view :key="$route.fullPath"></router-view>
</template>

<script>
import appConfig from "@/app.config";
import { notificationMethods } from "@/state/helpers";

export default {
  name: 'App',
  page: {
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.clearNotification();
    },
  },
  components: {
  },
  methods: {
    clearNotification: notificationMethods.clear,
  }
}
</script>
